module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/bg-f6429f3951af3bd212a327d466dae2e9.jpg";